import React, { Component } from 'react'
import Slider from 'rc-slider'
import MaskedInput from 'react-text-mask'
import Timer from '../common/Timer';

export default class ExchangeForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            gb: 0,
            timerOff: true,
            timerStart: false,
            disabledSubmitBtn: false,
            canChangeGuest: false,
            timerSeconds: 0,
            secondsDefault: 60,
            secondsExchange: 0,
            secondsExchangeDefault: 300,
            isSubmitExchange: false,
        }
        this.phoneMask = ['+', '7', ' ', /[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/]
        this.codeMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
    }

    componentDidMount() {
        window.addEventListener('beforeunload', ()=>{
            localStorage.setItem('attempts_seconds', String(this.state.timerSeconds))
        })

        if(!this.props.isGuest && this.props.timeExchange){

            const savedDate = new Date(this.props.timeExchange);
            const currentDate = new Date();
            const diffInSeconds = Math.floor((currentDate - savedDate) / 1000);
            if(300-diffInSeconds>0){
                this.setState({secondsExchangeDefault: 300-diffInSeconds});
            }

        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if(prevProps.timeExchange!==this.props.timeExchange && this.props.timeExchange){

            const savedDate = new Date(this.props.timeExchange);
            const currentDate = new Date();
            const diffInSeconds = Math.floor((currentDate - savedDate) / 1000);

            if(300-diffInSeconds>0){
                this.setState({secondsExchangeDefault: 300-diffInSeconds});
            }
        }



        if(this.props.codeError && this.state.timerStart){
            this.setState({timerStart: false})
        }

        if(prevProps.codeError && !this.props.codeError){
            this.setState({secondsDefault: 60})
        }


        if(this.props.phoneNumberStatus===3003 && this.state.timerStart){
            this.setState({timerStart: false})
        }

        if(this.props.phoneNumberStatus===140 && this.state.timerStart){
            this.setState({timerStart: false})
        }else if(this.props.phoneNumberStatus>0 && this.state.timerStart){
            this.setState({timerStart: false})
        }



        if(!prevState.timerSeconds){
            const seconds_from_storage = localStorage.getItem('attempts_seconds');
            const attempts = localStorage.getItem('attempts');
            if(Number(seconds_from_storage)>0 && Number(attempts)===3){
                this.setState({secondsDefault: Number(seconds_from_storage)})
            }else if(Number(seconds_from_storage)>0){
                this.setState({secondsDefault: Number(seconds_from_storage), timerStart: true})
            }
        }


        if(!prevState.timerSeconds>0 && !this.state.timerSeconds){
            localStorage.removeItem('attempts_seconds');
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (props.isSuccess) {
            return {
                ...state,
                value: 0,
                gb: 0,
                disabledSubmitBtn: false
            }
        }
    }

    onInputChange = (e) => {

        const regExp = /^\d+$/;



        if (e.target.value && regExp.test(e.target.value)) {
            var val = parseInt(e.target.value);
            if (val !== NaN) {
                if (val > this.props.max) {
                    this.onChange(this.props.max)
                } else if (val < 0) {
                    this.onChange(0)
                } else {
                    this.onChange(val)
                }
            }
        } else {
            this.onChange(0)
        }

    };

    onChange = (val) => {
        if(this.props.rate>0){
            let gb = (this.props.rate * val) / 1024;
            this.setState({ value: val, gb: (parseInt(gb) == gb) ? parseInt(gb) : gb.toFixed(2) })
        }

    };

    onSubmit = (e) => {
        e.preventDefault();
        this.props.onSubmit(JSON.stringify({ minutes: this.state.value }))
        this.setState({ disabledSubmitBtn: true }, () => {
            this.checkSubmitBtn()
        })
    };

    onSubmitGuest = (e) => {
        e.preventDefault()
        let data = { minutes: this.state.value, query_id: this.props.query, verify_code: this.props.verifyCode }
        this.props.onSubmit(data)


        this.setState({ disabledSubmitBtn: true }, () => {
            this.checkSubmitBtn()
        })
    }
    checkSubmitBtn = () => {
        setTimeout(() => {
            this.setState({ disabledSubmitBtn: false });
        }, 4000)
    }

    handlersendCode = () => {
        this.setState({timerStart: false});
    }

    checkIsExchanged(){
        const {phoneNumber} = this.props;
        const exchangePhoneNumber = localStorage.getItem('exchange-number')?JSON.parse(localStorage.getItem('exchange-number')):null;

        if(exchangePhoneNumber && exchangePhoneNumber.phoneNumber!==phoneNumber.replace(/\D/gim, '').slice(1)){
            localStorage.removeItem('exchange-number');
            this.props.resetExchangeTimer();
            this.props.check();
            this.setState({timerStart: true})
        }else{
            if(!exchangePhoneNumber){
                this.props.check();
            }else{
                if(!this.state.isSubmitExchange) {
                    this.setState({isSubmitExchange: true})
                }
            }

        }
    }
    render() {

        let {
            max,
            notice,
            title = 'Обменять минуты на гигабайты',
            client,
            isGuest,
            onInputChange,
            phoneNumber,
            sendNumberInfo,
            step,
            isSuccess,
            verifyCode,
            onCodeChange,
            codeError,
            setCodeError,
            isCorrect,
            check,
            phoneNumberStatus,
            exchangeDisabled,
            resetExchangeTimer,
            inProgress,
            isAvailable,
            exchangeStateError
        } = this.props;


        let {
            value,
            gb,
            disabledSubmitBtn,
            secondsExchangeDefault
        } = this.state;

        const isShowTimer = exchangeDisabled && this.state.isSubmitExchange;


        return <div className="mnp-popup-ok swiper-container mnp-popup__wrapper ex-min-popup" style={{padding:0}}>

            {!isGuest && <form className="" style={{lineHeight: '28px'}} onSubmit={this.onSubmit}>
                {title ? <div className="mnp-popup__title b-callback-form__title">{title}</div> : null}
                <div className='input__box' >
                    <div className=''>
                        <div className="ex-min-popup__text">ВВЕДИТЕ НОМЕР ТЕЛЕФОНА</div>
                        <MaskedInput
                            key={client && client.username}
                            mask={this.phoneMask}
                            type="text"
                            value={client && client.username}
                            guide={false}
                            disabled
                            className='input__number' />

                    </div>
                    <div>
                        <div className="ex-min-popup__text">ДОСТУПНЫЕ МИНУТЫ</div>
                        <input className='input__available__minutes' value={max} disabled />
                    </div>
                </div>

                <div style={{maxWidth:590}}>
                    <p className="ex-min-popup__text">ОБМЕНЯЙТЕ</p>

                    <div className="ex-min-popup__text-block">
                        <input className="ex-min-popup__minutes"  value={value} onChange={this.onInputChange} />
                        <p className='ex-min__minutes__text'>минут</p>
                    </div>

                    <Slider max={max} min={0} onChange={this.onChange} value={value} />

                    <p className="ex-min-popup__text">ПОЛУЧАЙТЕ</p>

                    <div className="ex-min-popup__block">
                        <b className="text_lg">{gb}</b>
                        <b className="ex-min-popup__bold-text__gb">Гб</b>
                    </div>

                    {
                        exchangeDisabled && <p className={`verify repeat-timer`}>Повторно обменять минуты можно через <Timer
                            key={secondsExchangeDefault}
                            seconds={secondsExchangeDefault}
                            callbackFunc={()=>{
                                localStorage.removeItem('exchange-number');
                                resetExchangeTimer();
                            }}
                            handlerSecond={(seconds)=>this.setState({secondsExchange: seconds})}
                            withMinutes={true}

                        /> мин</p>
                    }

                    <button type="submit"
                            disabled={exchangeDisabled}
                            className={`btn btn--mnp-next u-btn u-btn_default ${exchangeDisabled?'disabled':''} exchange_btn` + (value && !disabledSubmitBtn ? "" : " disabled")}
                            >
                        Обменять
                    </button>

                    {notice ? <div className="mnp-popup__bottom">{notice}</div> : null}
                </div>

            </form>}


            {isGuest && <form className="" onSubmit={this.onSubmitGuest}>
                {title ? <div className="mnp-popup__title b-callback-form__title">{title}</div> : null}
                <div className='input__box'>
                    <div>
                        <div className="ex-min-popup__text">ВВЕДИТЕ НОМЕР ТЕЛЕФОНА</div>
                        <MaskedInput
                            mask={this.phoneMask}
                            type="text"
                            placeholder='+7 ___-___-__-__'
                            value={phoneNumber}
                            onChange={onInputChange}
                            guide={false}
                            className={'input__number__guest' + (step == 3 || isShowTimer ? ' disabled' : '')}

                        />
                        {phoneNumberStatus == 3003  &&
                            <p className='check phone_error'>Номер не принадлежит Мотив</p>
                        }

                        {phoneNumberStatus == 140  &&
                            <p className='check phone_error'>Абонент не найден</p>
                        }

                        {phoneNumberStatus!==3003
                        && phoneNumberStatus!==140 &&
                        phoneNumberStatus>0 && exchangeStateError.message
                            && <p className='check phone_error'>{exchangeStateError.message}</p>}


                    </div>

                    <div>
                        <div className="ex-min-popup__text font-ubuntu">ДОСТУПНЫЕ МИНУТЫ</div>
                        <input
                            className='input__available__minutes'
                            value={step == 3 ? max : 0}
                            disabled
                        />
                    </div>
                </div>
                {step == 1 &&
                    <div>
                        <div className='guest_notice'>
                            Для получения доступного количества минут, пожалуйста, введите номер телефона.
                        </div>

                        {codeError &&
                            <p className='verify code_error'>Превышено количество попыток отправки кода.
                                Пожалуйста, проверьте введенный номер телефона
                                и попробуйте заново через  <Timer
                                    seconds={this.state.secondsDefault}
                                    handlerSecond={(seconds)=>this.setState({timerSeconds: seconds})}
                                    callbackFunc={() => setCodeError()}
                                    withMinutes={false}

                                /> сек.</p>
                        }

                        {
                            exchangeDisabled && <p className={`verify repeat-timer ${!isShowTimer?'opacity-0':''}`}>Повторно обменять минуты можно через <Timer
                                key={secondsExchangeDefault}
                                seconds={secondsExchangeDefault}
                                callbackFunc={()=>{
                                    localStorage.removeItem('exchange-number');
                                    this.setState({isSubmitExchange: false});
                                    resetExchangeTimer();
                                }}
                                handlerSecond={(seconds)=>this.setState({secondsExchange: seconds})}
                                withMinutes={true}

                            /> мин</p>
                        }

                        {!isAvailable && !phoneNumberStatus && <p className='verify code_error'>Обмен мин на Гб на Вашем номере недоступен</p>}

                        <button type="button"
                                disabled={isShowTimer || codeError}
                            onClick={()=>{
                                const exchangePhoneNumber = localStorage.getItem('exchange-number')?JSON.parse(localStorage.getItem('exchange-number')):null;
                                this.checkIsExchanged();
                                // if(exchangePhoneNumber && exchangePhoneNumber.phoneNumber === phoneNumber.replace(/\D/gim, '').slice(1)) {
                                //     if(!this.state.isSubmitExchange) {
                                //         this.setState({isSubmitExchange: true})
                                //     }
                                // }else{
                                //     check();
                                //     this.setState({timerStart: true})
                                // }



                            }}
                                style={{fontSize:16}}
                            className={"btn btn--mnp-next u-btn u-btn_default exchange_btn_send" + (phoneNumber.length !== 16 || codeError || inProgress || isShowTimer ? " disabled" : "")}>
                            {
                                inProgress ?
                                    <span className='loader' />
                                    :
                                    <span>Отправить код</span>
                            }
                        </button>

                    </div>
                }
                {step == 2 &&
                    <div>
                        <div className='guest_notice'>
                            На номер отправлено смс с кодом подтверждения. Введите полученный код ниже для завершения обмена.
                        </div>

                        <div className="ex-min-popup__text">ВВЕДИТЕ КОД</div>
                        <MaskedInput
                            mask={this.codeMask}
                            type="text"
                            placeholder='_ _ _ _ _ _'
                            value={verifyCode}
                            onChange={onCodeChange}
                            guide={false}
                            className={!isCorrect && verifyCode.length == 6 ? 'codeErrorInput' : 'input__number__guest'} />

                        {!isCorrect && verifyCode.length == 6 && <p className='verify code_error'>Код введен неверно</p>}

                        {codeError &&
                            <p className='verify code_error'>Превышено количество попыток отправки кода.
                                Пожалуйста, проверьте введенный номер телефона
                                и попробуйте заново через  <Timer
                                    seconds={this.state.secondsDefault}
                                    handlerSecond={(seconds)=>this.setState({timerSeconds: seconds})}
                                    callbackFunc={() => setCodeError()}
                                    withMinutes={false}

                                /> сек.</p>
                        }

                        {
                            this.state.timerStart && !codeError && <p className='verify repeat-timer'>Заказать код повторно можно через  <Timer
                                seconds={60}
                                handlerSecond={(seconds)=>this.setState({timerSeconds: seconds})}
                                callbackFunc={this.handlersendCode}
                                withMinutes={false}

                            /> сек.</p>
                        }
                        <button type="button" onClick={()=>{
                            sendNumberInfo();
                            this.setState({timerStart: true});
                        }} disabled={this.state.timerStart} style={{display:'block'}} className={"btn btn--mnp-next u-btn u-btn_default repeat" + (codeError || this.state.timerStart ? ' disabled' : '')}>Отправить код повторно</button>
                    </div>

                }
                {step == 3 &&
                    <div style={{maxWidth:590}}>
                        <p className="ex-min-popup__text">ОБМЕНЯЙТЕ</p>

                        <div className="ex-min-popup__text-block">
                            <input className="ex-min-popup__minutes" value={value} onChange={this.onInputChange} />
                            <p className='ex-min__minutes__text'>минут</p>
                        </div>

                        <Slider max={max} min={0} onChange={this.onChange} value={value} />

                        <p className="ex-min-popup__text">ПОЛУЧАЙТЕ</p>

                        <div className="ex-min-popup__block">
                            <b className="text_lg">{gb}</b>
                            <b className="ex-min-popup__bold-text__gb">Гб</b>
                        </div>

                        <button type="submit" className={"btn btn--mnp-next u-btn u-btn_default exchange_btn" + (value && !disabledSubmitBtn ? "" : " disabled")}>Обменять</button>
                        {notice ? <div className="mnp-popup__bottom">{notice}</div> : null}
                    </div>
                }
            </form>
            }
        </div>
    }
}